import {
  notifyError,
  notifySuccess,
} from "../../../../components/ToastContainer/Toast/Toast";
import { updateDish } from "../../../../service/BuyerConfiguration/DishManagement/dishService";

type PropsReusableUpdation = {
  id: number;
  payload: any;
  fetchData: () => Promise<void>;
  closeModal: () => void;
};

const reusableDishUpdation = async ({
  id,
  payload,
  fetchData,
  closeModal,
}: PropsReusableUpdation): Promise<void> => {
  try {
    const formData = new FormData();
    Object.entries(payload || {}).forEach(([key, value]) => {
      formData.append(key, String(value));
    });
    const response = await updateDish(id, formData);
    if (response.statusCode === 200 || response.statusCode === 201) {
      notifySuccess(response?.data?.message || "Updated successfully");
    }
  } catch (error) {
    notifyError(error?.response?.data?.message || "Something went wrong!");
  } finally {
    fetchData?.();
    closeModal?.();
  }
};

export { reusableDishUpdation };
